import axios from "axios";
import { useQuery } from "react-query";

const useGetLoggedInUser = () => {
  const { data, isLoading, error, refetch } = useQuery(
    ["getLoggedInUser"],
    async () => {
      return await axios.get("auth/getauthsCompany", {
        withCredentials: true,
      });
    },
    {
      staleTime: 5 * 60 * 1000, // 5 minutes - data is considered fresh for 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes - keep in cache for 10 minutes
      refetchOnMount: 'always', // Always refetch on mount, but staleTime prevents if data is fresh
      refetchOnWindowFocus: false, // Don't refetch when window gains focus
      retry: 2, // Retry twice on failure
      onError: (error) => {
        console.error('Error fetching logged in user data:', error);
      },
    }
  );
  return { data, isLoading, error, refetch };
};

export default useGetLoggedInUser;


